import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apifetch } from '../services/interceptors';
import { 
  TbArrowsExchange, 
  TbBuilding, 
  TbUserPlus, 
  TbBuildingCommunity,
  TbInfoCircle,
  TbEdit,
  TbX,
  TbCheck,
  TbTrash,
  TbLayoutGrid,
  TbTable,
  TbUpload
} from "react-icons/tb";
import { 
  FaBan, 
  FaUserCheck, 
  FaCrown,
  FaUser,
  FaLink,
  FaExclamationTriangle,
  FaGlobe,
  FaMapMarkerAlt,
  FaImage,
  FaFileAlt,
  FaSlidersH,
  FaPlug,
  FaKey
} from "react-icons/fa";
import { TbQrcode } from 'react-icons/tb';
import ThresholdManagement from './admin/ThresholdManagement';
import { Nav, Tab } from 'react-bootstrap';
import { 
  Button, 
  Tooltip,
  OverlayTrigger, 
  Spinner, 
  Modal, 
  Table,
  Card,
  Row,
  Col,
  Badge,
  Form,
  Alert,
  InputGroup,
  Container,
  ToggleButton,
  ButtonGroup
} from 'react-bootstrap';
import { useTheme } from "../ThemeContext";
import { 
  MdDeleteSweep,
  MdOutlineAdminPanelSettings,
  MdOutlinePersonRemove
} from "react-icons/md";
import './AdminPanel.css';
import Integration from './Integration';
import ScannerLinkGenerator from "./LocalhostOnly";
import { BRAND_SOURCE_PRESETS } from '../constants/colorPalettes';

function AdminPanel() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [orgTab, setOrgTab] = useState('orgs');
  const [orgSearchTerm, setOrgSearchTerm] = useState('');
  const [userType, setUserType] = useState('user');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usererror, setUserError] = useState(null);
  const [orgerror, setOrgError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [organizationName, setOrganizationName] = useState('');
  const [website, setWebsite] = useState('');

  const [primaryPerson, setPrimaryPerson] = useState('');
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [primaryPhone, setPrimaryPhone] = useState('');
  const [userOrganization, setUserOrganization] = useState('');
  const [showOrgForm, setShowOrgForm] = useState(false);
  const [message, setMessage] = useState('');
  const [orgmessage, setOrgMessage] = useState('');
  const [usermessage, setUserMessage] = useState('');
  const [error, setError] = useState(null);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUnbanModal, setShowUnbanModal] = useState(false);
  const [showDeletePermanentModal, setShowDeletePermanentModal] = useState(false);
  const [reloadUser, setReloadUser] = useState(false);
  const [showChangeRoleModel, setShowChangeRoleModel] = useState(false);
  const [showDeleteOrganization, setShowDeleteOrganization] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [orgIdToDelete, setOrgIdToDelete] = useState(null);
  const [userIdToChange, setUserIdToChange] = useState(null);
  const [activeTab, setActiveTab] = useState('users');
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('table'); // 'table' or 'card'
  const { isDarkMode } = useTheme();
  
  // Tenant state variables
  const [tenantData, setTenantData] = useState({
    tenant_name: '',
    tenant_domain: '',
    address: '',
    website: '',
    logo_url: '',
    large_logo_url: '',
    brand_colors: []
  });
  const [isEditingTenant, setIsEditingTenant] = useState(false);
  const [isLoadingTenant, setIsLoadingTenant] = useState(true);
  const [isSavingTenant, setIsSavingTenant] = useState(false);
  const [tenantMessage, setTenantMessage] = useState('');
  const [tenantError, setTenantError] = useState('');
  const [aiKeyTestStatus, setAiKeyTestStatus] = useState(null); // null | 'testing' | 'success' | 'error'
  const [aiKeyTestMessage, setAiKeyTestMessage] = useState('');

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await apifetch('s1/api/users', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          setUserError('Failed to fetch users');
          return;
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        setUserError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token, reloadUser]);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await apifetch('s1/api/organizations', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          setOrgError('Failed to fetch organizations');
          return;
        }
        const data = await response.json();
        setOrganizations(data.organizations);
        if (data.organizations && data.organizations.length > 0) {
          setUserOrganization(data.organizations[0].id);
        }
      } catch (err) {
        toast.error(err.message);
      }
    };

    fetchOrganizations();
  }, [token]);

  // Fetch tenant data
  useEffect(() => {
    const fetchTenantData = async () => {
      try {
        setIsLoadingTenant(true);
        setTenantError('');
        const response = await apifetch('/s1/api/tenant', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          setTenantError('Failed to fetch tenant information');
          return;
        }

        const data = await response.json();
        setTenantData(data);
      } catch (err) {
        console.error('Error fetching tenant data:', err);
        setTenantError(err.response?.data?.error || 'Failed to fetch tenant information');
      } finally {
        setIsLoadingTenant(false);
      }
    };

    if (activeTab === 'tenant' || activeTab === 'thresholds') {
      fetchTenantData();
    }
  }, [token, activeTab]);



  const CreateOrganization = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apifetch('s1/api/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ 
          primaryPerson,
          primaryEmail,
          primaryPhone,
          website,
          name: organizationName
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        setOrgError(data.error || "Can't create organization");
      } else {
        setOrganizations((prevOrg) => [...prevOrg, data.organization]);
        setOrganizationName('');
        setWebsite('');
        setPrimaryPerson('');
        setPrimaryEmail('');
        setPrimaryPhone('');
        setShowOrgForm(false);
        setOrgMessage('Organization created successfully');
      }
    } catch (error) {
      setOrgError(`Error creating organization: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newUser = { username, email, password, userType, organization_id: userOrganization };

    setLoading(true);
    try {
      const response = await apifetch('s1/api/create_user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newUser),
      });

      const data = await response.json();
      if (!response.ok) {
        setUserError(data.error || 'Error creating user');
      } else {
        setUsers((prevUsers) => [...prevUsers, data.user]);
        setUsername('');
        setEmail('');
        setPassword('');
        setUserType('user');
        setShowForm(false);
        setUserMessage('User created successfully');
      }
    } catch (error) {
      setUserError('Error creating user');
    } finally {
      setLoading(false);
    }
  };

  const handleInvertRole = (user_id, role) => {
    const updateRole = role === 1 ? 0 : 1;
    const updatedUsers = users.map(user => {
      if (user.user_id === user_id) {
        return { ...user, isadmin: updateRole };
      }
      return user;
    });

    const countadmins = updatedUsers.filter(user => user.isadmin === 1).length;

    if (countadmins === 0) {
      toast.error("Can't change role, at least one admin is mandatory!");
    } else {
      setUserIdToChange(user_id);
      setShowChangeRoleModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setError('');
      setMessage('');
      setOrgError('');
      setUserError('');
      setUserMessage('');
      setOrgMessage('');
      setTenantMessage('');
      setTenantError('');
    }, 4000);
    return () => clearTimeout(timer);
  }, [error, message, orgerror, usererror, usermessage, orgmessage, tenantMessage, tenantError]);

  const handleDelete = (user_id, current_ban_status) => {
    setUserIdToDelete(user_id);
    if (current_ban_status == 1) {
      setShowUnbanModal(true);
    } else {
      setShowDeleteModal(true);
    }
  };

  const handleDeletePermanent = (user_id) => {
    setUserIdToDelete(user_id);
    setShowDeletePermanentModal(true);
  };

  const handleDeleteOrganization = (id) => {
    setOrgIdToDelete(id);
    setShowDeleteOrganization(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await apifetch(`s1/api/users/${userIdToDelete}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const Data = await response.json();
      if (!response.ok) {
        setUserError(Data.error || "An unexpected error occurred");
        return;
      }

      setReloadUser(prev => !prev);
      setShowDeleteModal(false);
      setShowUnbanModal(false);
      setUserMessage(Data.message || "Changes successfully applied");
    } catch (error) {
      setError(error.message);
      setShowDeleteModal(false);
      setShowUnbanModal(false);
    }
  };

  const confirmDeletePermanently = async () => {
    try {
      const response = await apifetch(`s1/api/users/remove/${userIdToDelete}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const Data = await response.json();
      if (!response.ok) {
        setUserError(Data.error || "An unexpected error occurred");
        return;
      }

      setReloadUser(prev => !prev);
      setUserMessage(Data.message || "User permanently removed");
      setShowDeletePermanentModal(false);
    } catch (error) {
      setError(error.message);
    }
  };
const filteredOrgs = organizations.filter(org =>
  org.name.toLowerCase().includes(orgSearchTerm.toLowerCase())
);
  const confirmDeleteOrganization = async () => {
    try {
      const response = await apifetch(`s1/api/organization/remove/${orgIdToDelete}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const Data = await response.json();
      if (!response.ok) {
        setUserError(Data.error || "An unexpected error occurred");
        return;
      }
      setOrganizations((prev) => prev.filter(org => org.id !== orgIdToDelete));
      setShowDeleteOrganization(false);
      setOrgMessage('Organization deleted successfully');
    } catch (error) {
      setError(error.message);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setShowUnbanModal(false);
    setShowChangeRoleModel(false);
    setShowDeletePermanentModal(false);
    setShowDeleteOrganization(false);
    setCanDelete(false);
  };

  const confirmRole = async () => {
    try {
      const response = await apifetch(`s1/api/users/role/${userIdToChange}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const Data = await response.json();
      if (!response.ok) {
        setUserError(Data.error || "An unexpected error occurred");
      }

      setReloadUser(prev => !prev);
      setShowChangeRoleModel(false);
      setUserMessage(Data.message || "Role changed successfully");
    } catch (error) {
      setError(error.message);
      setShowChangeRoleModel(false);
    }
  };

  // Tenant functions
  const handleTenantInputChange = (e) => {
    const { name, value } = e.target;
    setTenantData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // ── Brand colors editing (ordered: index 0 = Primary, 1 = Secondary, 2 = Accent) ──
  const BRAND_COLOR_ROLES = ['Primary', 'Secondary', 'Accent'];
  const brandColorRole = (idx) => BRAND_COLOR_ROLES[idx] || `Extra ${idx - 2}`;

  const handleBrandColorChange = (index, value) => {
    setTenantData(prev => {
      const colors = [...(prev.brand_colors || [])];
      colors[index] = value;
      return { ...prev, brand_colors: colors };
    });
  };

  const handleAddBrandColor = () => {
    setTenantData(prev => {
      const colors = [...(prev.brand_colors || [])];
      if (colors.length >= 8) return prev; // cap to a sensible max
      colors.push('#000000');
      return { ...prev, brand_colors: colors };
    });
  };

  const handleRemoveBrandColor = (index) => {
    setTenantData(prev => ({
      ...prev,
      brand_colors: (prev.brand_colors || []).filter((_, i) => i !== index)
    }));
  };

  // Let the admin start from one of the Report Builder's existing Color Palette Presets
  // instead of typing hex codes from scratch. Fills Primary/Secondary/Accent from the
  // chosen preset; any extra (4th+) colors the tenant already had are left untouched, and
  // the result is still fully editable (swap swatches, add/remove colors) afterward.
  const handleApplyPresetToBrandColors = (presetId) => {
    const preset = BRAND_SOURCE_PRESETS.find(p => p.id === presetId);
    if (!preset) return;
    setTenantData(prev => {
      const colors = [...(prev.brand_colors || [])];
      colors[0] = preset.primary;
      colors[1] = preset.secondary;
      colors[2] = preset.accent;
      return { ...prev, brand_colors: colors };
    });
  };

  const handleSaveTenant = async () => {
    try {
      setIsSavingTenant(true);
      setTenantError('');
      setTenantMessage('');
      
      const response = await apifetch('s1/api/tenant/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...tenantData,
          ai_provider: tenantData.ai_provider || 'openai'
        })
      });

      const data = await response.json();
      if (!response.ok) {
        setTenantError(data.error || 'Failed to update tenant information');
        return;
      }

      setTenantMessage(data.message || 'Tenant information updated successfully');
      setIsEditingTenant(false);
      setAiKeyTestStatus(null);
      setAiKeyTestMessage('');
    } catch (err) {
      console.error('Error updating tenant data:', err);
      const errorMsg = err.response?.data?.error || 'Failed to update tenant information';
      setTenantError(errorMsg);
      
      // If it's a permission error, disable editing
      if (errorMsg.includes("don't have permission")) {
        setIsEditingTenant(false);
      }
    } finally {
      setIsSavingTenant(false);
    }
  };

  const [openaiTestStatus, setOpenaiTestStatus] = useState(null);
  const [openaiTestMessage, setOpenaiTestMessage] = useState('');
  const [anthropicTestStatus, setAnthropicTestStatus] = useState(null);
  const [anthropicTestMessage, setAnthropicTestMessage] = useState('');

  const handleTestAiKey = async (provider) => {
    const isOpenAI = provider === 'openai';
    const setStatus = isOpenAI ? setOpenaiTestStatus : setAnthropicTestStatus;
    const setMessage = isOpenAI ? setOpenaiTestMessage : setAnthropicTestMessage;
    
    setStatus('testing');
    setMessage('');
    
    try {
      const currentKey = isOpenAI ? tenantData.openai_api_key : tenantData.anthropic_api_key;
      const hasKey = isOpenAI ? tenantData.has_openai_key : tenantData.has_anthropic_key;
      // Only send the key if it's a fresh (unmasked) value
      const isNewKey = currentKey && !currentKey.includes('...') && currentKey !== '********';
      const body = { provider };
      if (isNewKey) body.api_key = currentKey;

      const response = await apifetch('s3/api/tenant/ai-key/test', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) {
        setStatus('error');
        setMessage(data.error || data.details || 'Connection test failed');
      } else {
        setStatus('success');
        setMessage(data.message || 'Connection successful!');
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Connection test failed');
    }
  };

  const handleCancelTenant = () => {
    // Re-fetch original data to reset any changes
    fetchTenantData();
    setIsEditingTenant(false);
    setTenantError('');
    setTenantMessage('');
  };

  const fetchTenantData = async () => {
    try {
      setIsLoadingTenant(true);
      setTenantError('');
      const response = await apifetch('s1/api/tenant', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        setTenantError('Failed to fetch tenant information');
        return;
      }

      const data = await response.json();
      setTenantData(data);
    } catch (err) {
      console.error('Error fetching tenant data:', err);
      setTenantError(err.response?.data?.error || 'Failed to fetch tenant information');
    } finally {
      setIsLoadingTenant(false);
    }
  };

  const filteredUsers = users.filter(user =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );




  const banTooltip = <Tooltip id="ban-tooltip">Temporarily Ban</Tooltip>;
  const removeTooltip = <Tooltip id="remove-tooltip">Permanently Remove</Tooltip>;
  const unbanTooltip = <Tooltip id="unban-tooltip">Lift Ban</Tooltip>;
  const adminTooltip = <Tooltip id="admin-tooltip">Promote to Admin</Tooltip>;
  const userTooltip = <Tooltip id="user-tooltip">Demote to User</Tooltip>;

  if (loading && users.length === 0 && organizations.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
        <span className="ms-3">Loading admin panel...</span>
      </div>
    );
  }

  return (
    <Container fluid className={`admin-panel-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0">
              <MdOutlineAdminPanelSettings className="me-2" />
              Admin Panel
            </h2>
            <div className="d-flex gap-2">
              <Button
                variant={activeTab === 'users' ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab('users')}
                className="d-flex align-items-center"
              >
                <TbUserPlus className="me-1" />
                Users
              </Button>
              <Button
                variant={activeTab === 'organizations' ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab('organizations')}
                className="d-flex align-items-center"
              >
                <TbBuildingCommunity className="me-1" />
                Organizations
              </Button>
              <Button
                variant={activeTab === 'tenant' ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab('tenant')}
                className="d-flex align-items-center"
              >
                <TbInfoCircle className="me-1" />
                Tenant
              </Button>
              <Button
                variant={activeTab === 'thresholds' ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab('thresholds')}
                className="d-flex align-items-center"
              >
                <FaSlidersH className="me-1" />
                Thresholds
              </Button>
              <Button
                variant={activeTab === 'integrations' ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab('integrations')}
                className="d-flex align-items-center"
              >
                <FaPlug className="me-1" />
                Integrations
              </Button>
              

            </div>
          </div>

          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)} className="mb-3">
              <FaExclamationTriangle className="me-2" />
              {error}
            </Alert>
          )}

{activeTab === 'organizations' && (
  <Card className="mb-4" bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
    <Card.Header className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0">
        <TbBuilding className="me-2" />
        Organizations ({organizations.length})
      </h5>
      <div className="d-flex gap-2">
        <ButtonGroup>
          <ToggleButton
            key="table"
            id="org-table-view"
            type="radio"
            variant={viewMode === 'table' ? 'primary' : 'outline-primary'}
            checked={viewMode === 'table'}
            onChange={() => setViewMode('table')}
            size="sm"
          >
            <TbTable className="me-1" />
            Table
          </ToggleButton>
          <ToggleButton
            key="card"
            id="org-card-view"
            type="radio"
            variant={viewMode === 'card' ? 'primary' : 'outline-primary'}
            checked={viewMode === 'card'}
            onChange={() => setViewMode('card')}
            size="sm"
          >
            <TbLayoutGrid className="me-1" />
            Cards
          </ToggleButton>
        </ButtonGroup>
        <Button
          variant="primary"
          size="sm"
          onClick={() => setShowOrgForm(!showOrgForm)}
          className="d-flex align-items-center"
        >
          {showOrgForm ? (
            <>
              <span className="me-1">Cancel</span>
            </>
          ) : (
            <>
              <TbBuilding className="me-1" />
              New Organization
            </>
          )}
        </Button>      </div>
    </Card.Header>
    <Card.Body>
      {/* Tab Navigation */}
      <Nav variant="tabs"   className={`mb-3 ${isDarkMode ? "dark-tabs" : ""}`}
 activeKey={orgTab} onSelect={(k) => setOrgTab(k)}>
        <Nav.Item>
          <Nav.Link eventKey="orgs">
            <TbBuilding className="me-1" />
            Organizations ({organizations.length})
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="scanner">
            <TbQrcode className="me-1" />
            Scanner Links
          </Nav.Link>
        </Nav.Item>
      </Nav>

      {/* Tab Content */}
      {orgTab === 'orgs' ? (
        /* Organizations Tab Content */
        <>
          {orgerror && (
            <Alert variant="danger" dismissible onClose={() => setOrgError(null)}>
              {orgerror}
            </Alert>
          )}
          {orgmessage && (
            <Alert variant="success" dismissible onClose={() => setOrgMessage(null)}>
              {orgmessage}
            </Alert>
          )}

          <div className="mb-3">
            <InputGroup>
              <InputGroup.Text>
                <TbBuilding color={isDarkMode?'white':'black'} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search organizations..."
                value={orgSearchTerm}
                onChange={(e) => setOrgSearchTerm(e.target.value)}
                className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
              />
            </InputGroup>
          </div>

          {showOrgForm && (
            <Card className="mb-4" bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
              <Card.Header>
                <h6 className="mb-0">Create New Organization</h6>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={CreateOrganization}>
                  <Form.Group className="mb-3">
                    <Form.Label>Organization Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={organizationName}
                      onChange={(e) => setOrganizationName(e.target.value)}
                      placeholder="Enter organization name"
                      required
                      className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Website (Domain)</Form.Label>
                    <Form.Control
                      type="text"
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                      placeholder="Enter organization website (e.g. example.com)"
                      className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Primary Person Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={primaryPerson}
                      onChange={(e) => setPrimaryPerson(e.target.value)}
                      placeholder="Enter primary contact name"
                      required
                      className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                    />
                  </Form.Group>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Primary Email</Form.Label>
                        <Form.Control
                          type="email"
                          value={primaryEmail}
                          onChange={(e) => setPrimaryEmail(e.target.value)}
                          placeholder="Enter email"
                          required
                          className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Primary Phone</Form.Label>
                        <Form.Control
                          type="tel"
                          value={primaryPhone}
                          onChange={(e) => setPrimaryPhone(e.target.value)}
                          placeholder="Enter phone"
                          required
                          className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button variant="success" type="submit" disabled={loading}>
                    {loading ? 'Creating...' : 'Create Organization'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          )}

          {filteredOrgs.length === 0 ? (
            <div className="text-center py-4">
              <TbBuilding size={48} className="mb-3" />
              <h6>No organizations found</h6>
              <p className="">
                {orgSearchTerm ? 'Try adjusting your search' : 'No organizations available yet'}
              </p>
              <Button 
                variant="primary" 
                size="sm" 
                onClick={() => setShowOrgForm(true)}
                className="mt-2"
              >
                <TbBuilding className="me-1" />
                Create First Organization
              </Button>
            </div>
          ) : viewMode === 'table' ? (
            <div className="table-responsive">
              <Table striped bordered hover variant={isDarkMode ? 'dark' : ''}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Created Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrgs.map((organization) => (
                    <tr key={organization.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <TbBuilding className="me-2 text-primary" />
                          {organization.name}
                        </div>
                      </td>
                      <td>
                        {organization.created_date !== 'now' 
                          ? new Date(organization.created_date).toLocaleString()
                          : 'Just Now'
                        }
                      </td>
                      <td>
                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete Organization</Tooltip>}>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteOrganization(organization.id)}
                          >
                            <MdDeleteSweep />
                          </Button>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <Row>
              {filteredOrgs.map((organization) => (
                <Col md={6} lg={4} className="mb-3" key={organization.id}>
                  <Card className="h-100 org-card" bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
                    <Card.Body className="d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h6 className="mb-1">
                            <TbBuilding className="me-2 text-primary" />
                            {organization.name}
                          </h6>
                          <p className="small mb-0">
                            Created: {organization.created_date !== 'now' 
                              ? new Date(organization.created_date).toLocaleDateString()
                              : 'Just Now'
                            }
                          </p>
                        </div>
                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete Organization</Tooltip>}>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteOrganization(organization.id)}
                            className="ms-2"
                          >
                            <TbTrash size={16} />
                          </Button>
                        </OverlayTrigger>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </>
      ) : (
        /* Scanner Links Tab Content */
        <div className="scanner-links-container">
          <ScannerLinkGenerator />
        </div>
      )}
    </Card.Body>
  </Card>
)}

          {activeTab === 'users' && (
            <Card bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <TbUserPlus className="me-2" />
                  Users
                </h5>
                <div className="d-flex gap-2">
                  <ButtonGroup>
                    <ToggleButton
                      key="table"
                      id="user-table-view"
                      type="radio"
                      variant={viewMode === 'table' ? 'primary' : 'outline-primary'}
                      checked={viewMode === 'table'}
                      onChange={() => setViewMode('table')}
                      size="sm"
                    >
                      <TbTable className="me-1" />
                      Table
                    </ToggleButton>
                    <ToggleButton
                      key="card"
                      id="user-card-view"
                      type="radio"
                      variant={viewMode === 'card' ? 'primary' : 'outline-primary'}
                      checked={viewMode === 'card'}
                      onChange={() => setViewMode('card')}
                      size="sm"
                    >
                      <TbLayoutGrid className="me-1" />
                      Cards
                    </ToggleButton>
                  </ButtonGroup>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => setShowForm(!showForm)}
                    className="d-flex align-items-center"
                  >
                    {showForm ? 'Cancel' : 'New User'}
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                {usererror && (
                  <Alert variant="danger" dismissible onClose={() => setUserError(null)}>
                    {usererror}
                  </Alert>
                )}
                {usermessage && (
                  <Alert variant="success" dismissible onClose={() => setUserMessage(null)}>
                    {usermessage}
                  </Alert>
                )}

                <div className="mb-3">
                  <InputGroup>
                    <InputGroup.Text>
                      <TbUserPlus color={isDarkMode?"white":'black'} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search users..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                    />
                  </InputGroup>
                </div>

                {showForm && (
                  <Card className="mb-4" bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
                    <Card.Header>
                      <h6 className="mb-0">Create New User</h6>
                    </Card.Header>
                    <Card.Body>
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Username</Form.Label>
                              <Form.Control
                                type="text"
                                value={username}
                                onChange={(e) => {
                                  setUserError('');
                                  setUsername(e.target.value);
                                }}
                                required
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setUserError('');
                                }}
                                required
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Password</Form.Label>
                              <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => {
                                  setUserError('');
                                  setPassword(e.target.value);
                                }}
                                required
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Organization</Form.Label>
                              <Form.Select
                                value={userOrganization}
                                onChange={(e) => {
                                  setUserError('');
                                  setUserOrganization(e.target.value);
                                }}
                                required
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                              >
                                {organizations.map((org) => (
                                  <option key={org.id} value={org.id}>
                                    {org.name}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Form.Group className="mb-3">
                          <Form.Label>User Type</Form.Label>
                          <Form.Select
                            value={userType}
                            onChange={(e) => {
                              setUserError('');
                              setUserType(e.target.value);
                            }}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                          >
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                          </Form.Select>
                        </Form.Group>
                        <Button variant="success" type="submit" disabled={loading}>
                          {loading ? 'Adding...' : 'Add User'}
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                )}

                {filteredUsers.length === 0 ? (
                  <div className="text-center py-4">
                    <TbUserPlus size={48} className=" mb-3" />
                    <h6>No users found</h6>
                    <p className="">
                      {searchTerm ? 'Try adjusting your search' : 'No users available yet'}
                    </p>
                  </div>
                ) : viewMode === 'table' ? (
                  <div className="table-responsive">
                    <Table striped bordered hover variant={isDarkMode ? 'dark' : ''}>
                      <thead>
                        <tr>
                          <th>Username</th>
                          <th>Email</th>
                          <th>Type</th>
                          <th>Created At</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredUsers.map((user) => (
                          <tr key={user.user_id}>
                            <td>
                              <div className="d-flex align-items-center">
                                {user.isadmin == 1 ? (
                                  <FaCrown className="me-2 text-warning" />
                                ) : (
                                  <FaUser className="me-2 text-secondary" />
                                )}
                                {user.username}
                              </div>
                            </td>
                            <td>{user.email}</td>
                            <td>
                              <Badge bg={user.isadmin == 1 ? 'warning' : 'secondary'}>
                                {user.isadmin == 1 ? 'Admin' : 'User'}
                              </Badge>
                            </td>
                            <td>
                              {user.created_at !== 'now'
                                ? new Date(user.created_at).toLocaleString()
                                : 'Now'
                              }
                            </td>
                            <td>
                              <Badge bg={user.banned == 1 ? 'danger' : 'success'}>
                                {user.banned == 1 ? 'Banned' : 'Active'}
                              </Badge>
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <OverlayTrigger placement="top" overlay={user.isadmin == 0 ? adminTooltip : userTooltip}>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => handleInvertRole(user.user_id, user.isadmin)}
                                  >
                                    <TbArrowsExchange />
                                  </Button>
                                </OverlayTrigger>
                                
                                <OverlayTrigger placement="top" overlay={removeTooltip}>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleDeletePermanent(user.user_id)}
                                  >
                                    <MdOutlinePersonRemove />
                                  </Button>
                                </OverlayTrigger>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <Row>
                    {filteredUsers.map((user) => (
                      <Col md={6} lg={4} className="mb-3" key={user.user_id}>
                        <Card className="h-100 user-card" bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div className="d-flex align-items-center">
                                {user.isadmin == 1 ? (
                                  <FaCrown className="me-2 text-warning" />
                                ) : (
                                  <FaUser className="me-2 text-secondary" />
                                )}
                                <div>
                                  <h6 className="mb-0">{user.username}</h6>
                                  <Badge bg={user.isadmin == 1 ? 'warning' : 'secondary'} className="mt-1">
                                    {user.isadmin == 1 ? 'Admin' : 'User'}
                                  </Badge>
                                </div>
                              </div>
                              <Badge bg={user.banned == 1 ? 'danger' : 'success'} className="ms-2">
                                {user.banned == 1 ? 'Banned' : 'Active'}
                              </Badge>
                            </div>
                            
                            <p className=" small mb-2">{user.email}</p>
                            
                            <p className=" small mb-3">
                              Created: {user.created_at !== 'now'
                                ? new Date(user.created_at).toLocaleDateString()
                                : 'Now'
                              }
                            </p>
                            
                            <div className="mt-auto d-flex justify-content-end gap-1">
                              <OverlayTrigger placement="top" overlay={user.isadmin == 0 ? adminTooltip : userTooltip}>
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => handleInvertRole(user.user_id, user.isadmin)}
                                >
                                  <TbArrowsExchange size={16} />
                                </Button>
                              </OverlayTrigger>
                        
                              <OverlayTrigger placement="top" overlay={removeTooltip}>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleDeletePermanent(user.user_id)}
                                >
                                  <MdOutlinePersonRemove size={16} />
                                </Button>
                              </OverlayTrigger>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </Card.Body>
            </Card>
          )}

          {activeTab === 'integrations' && (
            <Integration />
          )}


          {activeTab === 'tenant' && (
            <Card bg={isDarkMode ? 'dark' : 'light'} text={isDarkMode ? 'white' : 'dark'}>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <TbInfoCircle className="me-2" />
                  Tenant Information
                </h5>
                {!isEditingTenant && (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => setIsEditingTenant(true)}
                    className="d-flex align-items-center"
                  >
                    <TbEdit className="me-1" />
                    Edit
                  </Button>
                )}
              </Card.Header>
              <Card.Body>
                {tenantMessage && (
                  <Alert variant="success" dismissible onClose={() => setTenantMessage('')}>
                    {tenantMessage}
                  </Alert>
                )}
                {tenantError && (
                  <Alert variant="danger" dismissible onClose={() => setTenantError('')}>
                    {tenantError}
                  </Alert>
                )}

                {isLoadingTenant ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" variant="primary" />
                    <p style={{color:isDarkMode?'white':'black'}}  className="mt-2">Loading tenant information...</p>
                  </div>
                ) : (
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaUser className="me-2" />
                          Tenant Name
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="text"
                            name="tenant_name"
                            value={tenantData.tenant_name}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}} 
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.tenant_name}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaGlobe className="me-2" />
                          Domain
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="text"
                            name="tenant_domain"
                            value={tenantData.tenant_domain}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}} 
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.tenant_domain}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <TbCheck className="me-2" />
                          Key Findings Threshold (%)
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="number"
                            min="0"
                            max="100"
                            name="acceptable_score_threshold"
                            value={tenantData.acceptable_score_threshold ?? ''}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}} 
                            placeholder="Default: 20"
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.acceptable_score_threshold ?? 20}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <TbCheck className="me-2" />
                          Customer Report Style
                        </Form.Label>
                        {isEditingTenant ? (
                          <>
                            <Form.Select
                              name="report_style"
                              value={tenantData.report_style || 'pdf'}
                              onChange={handleTenantInputChange}
                              className={isDarkMode ? 'bg-dark text-light' : ''}
                              style={{color:isDarkMode?'white':'black'}}
                            >
                              <option value="pdf">PDF / Single-page report (default)</option>
                              <option value="slide_deck">Slide deck presentation</option>
                            </Form.Select>
                            <Form.Text className={isDarkMode ? 'text-light opacity-75' : 'text-muted'}>
                              How your customer-facing scans (lead magnet &amp; scan links) are presented. Your internal External Risk Scan always uses the slide deck.
                            </Form.Text>
                          </>
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">
                            {tenantData.report_style === 'slide_deck' ? 'Slide deck presentation' : 'PDF / Single-page report'}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ── Report branding: shown on the cover + closing of customer reports ── */}
                    <Col md={12}>
                      <div className={`mb-2 fw-semibold ${isDarkMode ? 'text-light' : ''}`}>Report Branding</div>
                      <div className={`mb-3 small ${isDarkMode ? 'text-light opacity-75' : 'text-muted'}`}>
                        Your logo and brand colors (set above) appear on the cover and closing of every customer-facing report. These contact details appear on the closing section.
                      </div>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Phone</Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="tel"
                            name="contact_phone"
                            value={tenantData.contact_phone || ''}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}}
                            placeholder="+1 (555) 123-4567"
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.contact_phone || '—'}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Email</Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="email"
                            name="contact_email"
                            value={tenantData.contact_email || ''}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}}
                            placeholder="hello@yourcompany.com"
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.contact_email || '—'}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Report Tagline</Form.Label>
                        {isEditingTenant ? (
                          <>
                            <Form.Control
                              type="text"
                              name="report_tagline"
                              value={tenantData.report_tagline || ''}
                              onChange={handleTenantInputChange}
                              className={isDarkMode ? 'bg-dark text-light' : ''}
                              style={{color:isDarkMode?'white':'black'}}
                              placeholder="e.g. Security that lets you focus on your business."
                              maxLength={255}
                            />
                            <Form.Text className={isDarkMode ? 'text-light opacity-75' : 'text-muted'}>
                              Optional closing line shown under the "Thank You" section of the report.
                            </Form.Text>
                          </>
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}} className="form-control-plaintext">{tenantData.report_tagline || '—'}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaKey className="me-2" />
                          AI Provider &amp; API Keys (Tenant-wide)
                        </Form.Label>
                        {isEditingTenant ? (
                          <>
                            <Form.Label className="small text-muted mb-1">Active AI Provider</Form.Label>
                            <Form.Select
                              name="ai_provider"
                              value={tenantData.ai_provider || 'openai'}
                              onChange={(e) => handleTenantInputChange(e)}
                              className={`mb-3 ${isDarkMode ? 'bg-dark text-light' : ''}`}
                              style={{color: isDarkMode ? 'white' : 'black'}}
                            >
                              <option value="openai">OpenAI</option>
                              <option value="anthropic">Anthropic (Claude)</option>
                            </Form.Select>

                            <Form.Label className="small text-muted mb-1 mt-2">OpenAI API Key</Form.Label>
                            <InputGroup className="mb-2">
                              <Form.Control
                                type="password"
                                name="openai_api_key"
                                value={tenantData.openai_api_key !== undefined ? tenantData.openai_api_key : (tenantData.has_openai_key ? '********' : '')}
                                onChange={(e) => {
                                  handleTenantInputChange(e);
                                  setOpenaiTestStatus(null);
                                  setOpenaiTestMessage('');
                                }}
                                placeholder={tenantData.has_openai_key ? '******** (API Key Configured)' : 'Enter OpenAI API Key (sk-...)'}
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                                style={{color: isDarkMode ? 'white' : 'black'}}
                              />
                              <Button
                                variant={openaiTestStatus === 'success' ? 'success' : openaiTestStatus === 'error' ? 'danger' : 'outline-secondary'}
                                onClick={() => handleTestAiKey('openai')}
                                disabled={openaiTestStatus === 'testing' || (!tenantData.openai_api_key && !tenantData.has_openai_key)}
                                style={{ minWidth: '130px' }}
                              >
                                {openaiTestStatus === 'testing' ? (
                                  <><Spinner animation="border" size="sm" className="me-1" />Testing...</>
                                ) : openaiTestStatus === 'success' ? (
                                  <><TbCheck className="me-1" />Connected!</>
                                ) : openaiTestStatus === 'error' ? (
                                  <><TbX className="me-1" />Failed</>
                                ) : (
                                  'Test Connection'
                                )}
                              </Button>
                            </InputGroup>
                            {openaiTestMessage && (
                              <div className={`mt-1 mb-3 small ${openaiTestStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                                {openaiTestMessage}
                              </div>
                            )}

                            <Form.Label className="small text-muted mb-1 mt-2">Anthropic API Key</Form.Label>
                            <InputGroup className="mb-2">
                              <Form.Control
                                type="password"
                                name="anthropic_api_key"
                                value={tenantData.anthropic_api_key !== undefined ? tenantData.anthropic_api_key : (tenantData.has_anthropic_key ? '********' : '')}
                                onChange={(e) => {
                                  handleTenantInputChange(e);
                                  setAnthropicTestStatus(null);
                                  setAnthropicTestMessage('');
                                }}
                                placeholder={tenantData.has_anthropic_key ? '******** (API Key Configured)' : 'Enter Anthropic API Key (sk-ant-...)'}
                                className={isDarkMode ? 'bg-dark text-light' : ''}
                                style={{color: isDarkMode ? 'white' : 'black'}}
                              />
                              <Button
                                variant={anthropicTestStatus === 'success' ? 'success' : anthropicTestStatus === 'error' ? 'danger' : 'outline-secondary'}
                                onClick={() => handleTestAiKey('anthropic')}
                                disabled={anthropicTestStatus === 'testing' || (!tenantData.anthropic_api_key && !tenantData.has_anthropic_key)}
                                style={{ minWidth: '130px' }}
                              >
                                {anthropicTestStatus === 'testing' ? (
                                  <><Spinner animation="border" size="sm" className="me-1" />Testing...</>
                                ) : anthropicTestStatus === 'success' ? (
                                  <><TbCheck className="me-1" />Connected!</>
                                ) : anthropicTestStatus === 'error' ? (
                                  <><TbX className="me-1" />Failed</>
                                ) : (
                                  'Test Connection'
                                )}
                              </Button>
                            </InputGroup>
                            {anthropicTestMessage && (
                              <div className={`mt-1 mb-2 small ${anthropicTestStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                                {anthropicTestMessage}
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{color: isDarkMode ? 'white' : 'black'}} className="form-control-plaintext">
                            <div>
                              <strong>Active Provider:</strong> {tenantData.ai_provider === 'anthropic' ? 'Anthropic' : 'OpenAI'}
                            </div>
                            <div className="mt-2">
                              <strong>OpenAI Key:</strong>{' '}
                              {tenantData.has_openai_key ? (
                                <span className="text-success">Configured — {tenantData.masked_openai_key || '********'}</span>
                              ) : (
                                <span className="text-muted">Not Configured</span>
                              )}
                            </div>
                            <div className="mt-1">
                              <strong>Anthropic Key:</strong>{' '}
                              {tenantData.has_anthropic_key ? (
                                <span className="text-success">Configured — {tenantData.masked_anthropic_key || '********'}</span>
                              ) : (
                                <span className="text-muted">Not Configured</span>
                              )}
                            </div>
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaMapMarkerAlt className="me-2" />
                          Address
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            value={tenantData.address || ''}
                            onChange={handleTenantInputChange}
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                            style={{color:isDarkMode?'white':'black'}} 
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}}  className="form-control-plaintext">{tenantData.address || 'Not specified'}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaGlobe className="me-2" />
                          Website
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="url"
                            name="website"
                            value={tenantData.website || ''}
                            onChange={handleTenantInputChange}
                            placeholder="https://example.com"
                            className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                            style={{color:isDarkMode?'white':'black'}} 
                          />
                        ) : (
                          <div style={{color:isDarkMode?'white':'black'}}  className="form-control-plaintext">
                            {tenantData.website ? (
                              <a href={tenantData.website} target="_blank" rel="noopener noreferrer">
                                {tenantData.website}
                              </a>
                            ) : (
                              'Not specified'
                            )}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaImage className="me-2" />
                          Logo URL
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="url"
                            name="logo_url"
                            value={tenantData.logo_url || ''}
                            onChange={handleTenantInputChange}
                            placeholder="https://example.com/logo.png"
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                          />
                        ) : (
                          <div className="form-control-plaintext">
                            {tenantData.logo_url ? (
                              <>
                                <a href={tenantData.logo_url} target="_blank" rel="noopener noreferrer" className="me-2">
                                  View Logo
                                </a>
                                {tenantData.logo_url && (
                                  <img 
                                    src={tenantData.logo_url} 
                                    alt="Tenant Logo" 
                                    className="tenant-logo-preview"
                                    style={{maxHeight: '30px'}}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              'Not specified'
                            )}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaImage className="me-2" />
                          Large Logo URL
                        </Form.Label>
                        {isEditingTenant ? (
                          <Form.Control
                            type="url"
                            name="large_logo_url"
                            value={tenantData.large_logo_url || ''}
                            onChange={handleTenantInputChange}
                            placeholder="https://example.com/large-logo.png"
                            className={isDarkMode ? 'bg-dark text-light' : ''}
                          />
                        ) : (
                          <div className="form-control-plaintext">
                            {tenantData.large_logo_url ? (
                              <>
                                <a href={tenantData.large_logo_url} target="_blank" rel="noopener noreferrer" className="me-2">
                                  View Large Logo
                                </a>
                                {tenantData.large_logo_url && (
                                  <img 
                                    src={tenantData.large_logo_url} 
                                    alt="Tenant Large Logo" 
                                    className="tenant-logo-preview"
                                    style={{maxHeight: '50px'}}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              'Not specified'
                            )}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaImage className="me-2" />
                          Brand Colors
                        </Form.Label>
                        {isEditingTenant ? (
                          <div>
                            <small className={`d-block mb-2 ${isDarkMode ? 'text-light opacity-75' : 'text-muted'}`}>
                              Your business's brand color palette. The first three (Primary, Secondary, Accent) become the default Color Palette in the AI Report Builder.
                            </small>
                            <div className="mb-3" style={{ maxWidth: '340px' }}>
                              <Form.Label className="small fw-semibold mb-1">
                                Start from a Report Builder preset (optional)
                              </Form.Label>
                              <Form.Select
                                size="sm"
                                defaultValue=""
                                className={isDarkMode ? 'bg-dark text-light border-secondary' : ''}
                                onChange={(e) => {
                                  if (e.target.value) handleApplyPresetToBrandColors(e.target.value);
                                  e.target.value = ''; // reset to placeholder — this is an action, not a persistent selection
                                }}
                              >
                                <option value="">Choose a preset to copy its colors…</option>
                                {BRAND_SOURCE_PRESETS.map(preset => (
                                  <option key={preset.id} value={preset.id}>{preset.name}</option>
                                ))}
                              </Form.Select>
                              <small className={isDarkMode ? 'text-light opacity-75' : 'text-muted'}>
                                Fills Primary/Secondary/Accent below — or skip this and set your own colors directly.
                              </small>
                            </div>
                            <div className="d-flex flex-wrap gap-3">
                              {(tenantData.brand_colors || []).map((color, idx) => (
                                <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                                  <span style={{ fontSize: '0.7rem', fontWeight: 600, color: isDarkMode ? '#cbd5e1' : '#475569' }}>{brandColorRole(idx)}</span>
                                  <Form.Control
                                    type="color"
                                    value={/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color || '') ? color : '#000000'}
                                    onChange={(e) => handleBrandColorChange(idx, e.target.value)}
                                    title={`${brandColorRole(idx)} color`}
                                    style={{ width: '52px', height: '40px', padding: '2px', cursor: 'pointer' }}
                                  />
                                  <Form.Control
                                    type="text"
                                    value={color || ''}
                                    onChange={(e) => handleBrandColorChange(idx, e.target.value)}
                                    placeholder="#000000"
                                    className={isDarkMode ? 'bg-dark text-light' : ''}
                                    style={{ width: '90px', fontSize: '0.75rem', textAlign: 'center' }}
                                  />
                                  <Button variant="link" size="sm" className="text-danger p-0" style={{ fontSize: '0.7rem' }} onClick={() => handleRemoveBrandColor(idx)}>
                                    Remove
                                  </Button>
                                </div>
                              ))}
                              {(tenantData.brand_colors || []).length < 8 && (
                                <Button
                                  variant="outline-secondary"
                                  onClick={handleAddBrandColor}
                                  style={{ alignSelf: 'center', height: '40px' }}
                                >
                                  + Add Color
                                </Button>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="form-control-plaintext">
                            {(tenantData.brand_colors || []).length > 0 ? (
                              <div className="d-flex flex-wrap gap-3">
                                {tenantData.brand_colors.map((color, idx) => (
                                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span style={{ display: 'inline-block', width: '22px', height: '22px', borderRadius: '4px', backgroundColor: color, border: '1px solid rgba(0,0,0,0.2)' }} />
                                    <span style={{ fontSize: '0.8rem', color: isDarkMode ? '#cbd5e1' : '#475569' }}>
                                      {brandColorRole(idx)}: {color}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              'Not specified'
                            )}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {isEditingTenant && (
                      <Col md={12}>
                        <div className="d-flex gap-2 mt-3">
                          <Button 
                            variant="success" 
                            onClick={handleSaveTenant}
                            disabled={isSavingTenant}
                            className="d-flex align-items-center"
                          >
                            <TbCheck className="me-1" />
                            {isSavingTenant ? 'Saving...' : 'Save Changes'}
                          </Button>
                          <Button 
                            variant="secondary" 
                            onClick={handleCancelTenant}
                            className="d-flex align-items-center"
                          >
                            <TbX className="me-1" />
                            Cancel
                          </Button>
                          <Button
                            variant="info"
                            onClick={() => { /* handle upload config file logic */ }}
                            className="d-flex align-items-center"
                          >
                            <TbUpload className="me-1" />
                            Upload Configuration File
                          </Button>
                        </div>
                      </Col>
                    )}
                  </Row>
                )}
              </Card.Body>
            </Card>
          )}

          {activeTab === 'thresholds' && (
             <ThresholdManagement tenantId={tenantData?.tenant_id} />
          )}

          {/* Modals */}
          <Modal show={showDeleteModal} onHide={cancelDelete} centered>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
              <Modal.Title>Confirm Ban</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
              <p>Are you sure you want to ban this user?</p>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
              <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
              <Button variant="danger" onClick={confirmDelete}>Confirm Ban</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showUnbanModal} onHide={cancelDelete} centered>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
              <Modal.Title>Confirm Unban</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
              <p>Are you sure you want to unban this user?</p>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
              <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
              <Button variant="success" onClick={confirmDelete}>Confirm Unban</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showChangeRoleModel} onHide={cancelDelete} centered>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
              <Modal.Title>Confirm Role Change</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
              <p>Are you sure you want to change this user's role?</p>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
              <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
              <Button variant="warning" onClick={confirmRole}>Confirm Change</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showDeletePermanentModal} onHide={cancelDelete} centered>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
              <Modal.Title>Confirm Permanent Removal</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
              <p>Are you sure you want to permanently remove this user? This action cannot be undone.</p>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
              <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
              <Button variant="danger" onClick={confirmDeletePermanently}>Remove Permanently</Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showDeleteOrganization} onHide={cancelDelete} centered>
            <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
              <Modal.Title>Confirm Organization Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
              <p>To confirm the deletion of this organization, type <strong>DELETE</strong> below.</p>
              <Form.Control
                type="text"
                placeholder="Type 'DELETE' to confirm"
                onChange={(e) => setCanDelete(e.target.value === "DELETE")}
                className={`mb-3 ${isDarkMode ? 'bg-dark text-light' : ''}`}
              />
              <Alert variant="warning">
                <FaExclamationTriangle className="me-2" />
                Warning: This action will permanently delete the organization and all associated data.
              </Alert>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
              <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
              <Button variant="danger" onClick={confirmDeleteOrganization} disabled={!canDelete}>
                Delete Organization
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPanel;